import {isEmpty} from "lodash";
import { getUrlToResolveOidcParams } from "../../utils/oidcService";

export const samlRedirect = (samsParam) => {
  console.log("start samlRedirect = ");
  const relayState = getRelayState(samsParam);
  const redirectUrl = getSamlUrlFromWindowLocation(samsParam);
  const separator = redirectUrl.indexOf("?") === -1 ? "?" : "&";

  let result;
  if (isEmpty(samsParam.sessionToken)) {
    if (isEmpty(relayState)) {
      result = redirectUrl;
    } else {
      result =  `${redirectUrl}${separator}RelayState=${encodeURIComponent(
        relayState
      )}`;
    }
  } else {
    if (isEmpty(relayState)) {
      result =  `${redirectUrl}${separator}sessionToken=${samsParam.sessionToken}`;
    } else {
      result =  `${redirectUrl}${separator}RelayState=${encodeURIComponent(
        relayState
      )}&sessionToken=${samsParam.sessionToken}`;
    }
  }
  console.log("end samlRedirect = "+result);
  return result;
};

const getSamlUrlFromWindowLocation = (samsParam) => {
  if (!isEmpty(samsParam.logonUrl)) return samsParam.logonUrl;
  if (!isEmpty(samsParam.fromURI)) return samsParam.fromURI;
  return getUrlToResolveOidcParams(window.location.hostname);
};

const getRelayState = (samsParam) => {
  if (!isEmpty(samsParam.originalTarget)) return samsParam.originalTarget;
  if (!isEmpty(samsParam.relayState)) return samsParam.relayState;
};
